import {
  leadPipelineStages,
  type LeadPipelineStage,
} from "@whitehaven/contracts";

export const leadPipelineStageOrder = leadPipelineStages;

export const leadPipelineStageLabels = {
  NEW: "New",
  CONTACTED: "Contacted",
  QUALIFIED: "Qualified",
  APPOINTMENT_HELD: "Appointment held",
  BOOKED: "Booked",
  VISITED: "Visited",
  FOLLOW_UP: "Follow up",
  WON: "Won",
  LOST: "Lost",
  DO_NOT_CONTACT: "Do not contact",
} as const satisfies Readonly<Record<LeadPipelineStage, string>>;

const leadPipelineStageSet: ReadonlySet<string> = new Set(
  leadPipelineStageOrder,
);

export function isLeadPipelineStage(
  value: unknown,
): value is LeadPipelineStage {
  return typeof value === "string" && leadPipelineStageSet.has(value);
}

export function compareLeadPipelineStages(
  left: LeadPipelineStage,
  right: LeadPipelineStage,
): number {
  return (
    leadPipelineStageOrder.indexOf(left) - leadPipelineStageOrder.indexOf(right)
  );
}
